/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Q41Inputs */

const en__field_enum_q41 = /** @type {(inputs: _Field_Enum_Q41Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q4`)
};

const de__field_enum_q41 = /** @type {(inputs: _Field_Enum_Q41Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q4`)
};

/**
* | output |
* | --- |
* | "Q4" |
*
* @param {_Field_Enum_Q41Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_q41 = /** @type {((inputs?: _Field_Enum_Q41Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Q41Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_q41(inputs)
	return de__field_enum_q41(inputs)
});
export { _field_enum_q41 as "_field_enum_Q4" }